import styled from 'styled-components'
import NavBar from 'components/NavBar'

export const StyledCategoryGrid = styled.div`
	display: flex;
`

export const StyledGrid = styled.div`
	background-color: #ffffff;
	padding-top: 10px;
	padding-left: 10px;
	overflow: scroll;
  & > div {
		display: flex;
		flex-wrap: wrap;
		margin: auto;
  	align-content: space-between;
  	word-break: break-word;
  	max-height: 650px;
  }
`

export const StyledNavBar = styled(NavBar)`
	min-width: 600px;
	margin-right: 30px;
	flex-grow: 1;
`
